module.exports = __webpack_public_path__ + "./fonts/Barlow-Medium.otf";